import { cn } from "@/lib/utils";
import { CoachingStyle, COACHING_STYLES } from "@/types/evolve";
import { Check } from "lucide-react";

interface CoachPickerProps {
  selected: CoachingStyle;
  onChange: (style: CoachingStyle) => void;
  compact?: boolean;
}

export function CoachPicker({ selected, onChange, compact = false }: CoachPickerProps) {
  return (
    <div className={cn("space-y-2", compact && "space-y-1")}>
      {COACHING_STYLES.map((style) => (
        <button
          key={style.value}
          onClick={() => onChange(style.value)}
          className={cn(
            "w-full p-4 rounded-lg border transition-all text-left flex items-start gap-3",
            selected === style.value
              ? "border-primary bg-primary/10"
              : "border-border/50 hover:border-primary/50 bg-secondary/30",
            compact && "p-3"
          )}
        >
          <span className="text-2xl">{style.emoji}</span>
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <span className={cn("font-medium", compact && "text-sm")}>{style.label}</span>
              {selected === style.value && (
                <Check className="w-4 h-4 text-primary" />
              )}
            </div>
            <p className={cn("text-muted-foreground mt-1", compact ? "text-xs" : "text-sm")}>
              {style.description}
            </p>
          </div>
        </button>
      ))}
    </div>
  );
}
